import React, { useEffect } from 'react'
import { useNav } from './NavProvider'
import { SubNavLink } from './SubNav'

const PopupSubNav = ({
  popupRef,
  menuRef,
  menuId,
  slug,
  items,
  isOpen,
  onMenuItemKeyDown,
}) => {
  const { popupSubNav, setPopupSubNav, currentTimer } = useNav()
  const active = slug === popupSubNav

  useEffect(() => {
    const handleClick = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setPopupSubNav(null)
      }
    }
    if (active) document.addEventListener('mousedown', handleClick)
    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [popupRef, setPopupSubNav, active])

  const setHovering = (e) => {
    clearTimeout(currentTimer.current)
    setPopupSubNav(slug)
    e.stopPropagation()
  }
  const setNotHovering = (e) => {
    clearTimeout(currentTimer.current)
    const timerId = setTimeout(() => {
      setPopupSubNav(null)
    }, 1000)
    // eslint-disable-next-line react-hooks/immutability -- shared nav timer ref from context
    currentTimer.current = timerId
    e.stopPropagation()
  }

  const popupClasses = slug == popupSubNav ? 'visible' : 'invisible'

  if (!items) {
    return null
  }
  return (
    <div
      ref={popupRef}
      className={popupClasses}
      onMouseOver={setHovering}
      onMouseOut={setNotHovering}
    >
      <div
        ref={menuRef}
        id={menuId || undefined}
        role={menuId ? 'menu' : undefined}
        aria-hidden={menuId ? !isOpen : undefined}
        className="fixed left-24 flex flex-col gap-2 rounded-xl border border-solid border-[#0000001a] bg-white p-2 shadow-xl"
      >
        {items.map((child, childIndex) => (
          <SubNavLink
            key={childIndex}
            item={child}
            onMenuItemKeyDown={onMenuItemKeyDown}
          />
        ))}
      </div>
    </div>
  )
}
export default PopupSubNav
